export interface PaletteEntry {
  readonly bg: string;
  readonly text: string;
}

const FALLBACK_ENTRY: PaletteEntry = { bg: 'bg-blue-500', text: 'text-white' };

// Brand-blue subset only so solid-colour and dithered-pattern avatars share
// the same identity colour family.
export const PALETTE: readonly PaletteEntry[] = [
  { bg: 'bg-sky-600', text: 'text-white' },
  { bg: 'bg-blue-600', text: 'text-white' },
  { bg: 'bg-indigo-600', text: 'text-white' },
  { bg: 'bg-cyan-700', text: 'text-white' },
  { bg: 'bg-sky-700', text: 'text-white' },
  { bg: 'bg-blue-700', text: 'text-white' },
  { bg: 'bg-indigo-700', text: 'text-white' },
  { bg: 'bg-blue-500', text: 'text-white' },
] as const;

export type GetInitialsMaxChars = 1 | 2;

/** Returns up to `maxChars` uppercased characters, or anonymous glyphs. */
export function getInitials(
  displayName: string | null,
  options?: { readonly maxChars?: GetInitialsMaxChars },
): string {
  const maxChars = options?.maxChars ?? 2;
  if (displayName === null || displayName.length === 0) {
    return maxChars === 1 ? 'A' : 'AN';
  }
  return Array.from(displayName).slice(0, maxChars).join('').toUpperCase();
}

/** Stable sum-of-code-points hash into the avatar palette. */
export function hashDisplayName(displayName: string): number {
  let sum = 0;
  for (let i = 0; i < displayName.length; i += 1) {
    sum = (sum + displayName.charCodeAt(i)) >>> 0;
  }
  return sum % PALETTE.length;
}

export function getPaletteEntry(displayName: string): PaletteEntry {
  return PALETTE[hashDisplayName(displayName)] ?? FALLBACK_ENTRY;
}
